import $ from 'jquery';
import axios from 'axios';
import {
	Modal,
	message as message1,
	notification,
} from 'antd';

export const CommonConfig=(()=>{
	return {
		'isDebug':'development' == process.env.NODE_ENV,
		'siteName': process.env.REACT_APP_SITE_NAME,
		'hostUrl': process.env.REACT_APP_API_URL,
	};
})();

export const CommonValue={
	'value':{},
	/*
	'get':async (key)=>{
		return JSON.parse(localStorage.getItem(key));
	},
	*/
	'get':(key)=>{
		try
		{
			return JSON.parse(localStorage.getItem(key));
		}
		catch(e)
		{
			return localStorage.getItem(key);
		}
	},
	'set':(key,value)=>{
		if(typeof(value)=='object')
			value=JSON.stringify(value);
		
		//this.value[key]=value;
		localStorage.setItem(key,value);
	},
	'remove':(key)=>{
		//delete(this.value[key]);
		localStorage.clear(key);
	},
};

export const url = (url,params) =>{
	var preUrl=CommonConfig.isDebug?'/api':CommonConfig.hostUrl;
	url=preUrl+url;
	
	url+='?';
	for(var i in params)
	{
		url+=i+'='+params[i]+'&';
	}
	url=url.substr(0,url.length-1);
	return url;
};

export const pcUrl = (c,a,params) =>{
	var _url='/rest';
	_url+='/'+c;
	if(a!=undefined)
		_url+='/'+a;

	return url(_url,params);
};

export const ngUrl = (c,a,params,isQuery)=>{
	if(typeof(a)=='object')
	{
		isQuery=params;
		params=a;
		a='';
	}
	let url='#/'+c;
	if(a!=undefined && a)
		url+='/'+a;
	
	if(isQuery)
	{
		url+='?';
		for(let i in params)
		{
			url+=i+'='+params[i]+'&';
		}
		url=url.substr(0,url.length-1);
	}
	else
	{
		for(let i in params)
		{
			url+='/'+params[i];
		}
	}
	
	return url;
};

/*
 config = {rawResponse=false,hideAjax=false,onUploadProgress=null,onDownloadProgress=null}
  */
export const httpPost = (url,param,config)=> {
	if(param==undefined)
		param={};
	if(config == undefined)
		config = {};
	//转换param为post格式
	/*
	let data=new FormData();
	for(let i in param)
		data.append(i,param[i]);
	*/
	//转换为json格式
	//let data=JSON.stringify(param);
	
	return new Promise((resolve,reject)=>{
		if(!config.hideAjax)
		{
			let rootState = {
				'isLoading':true,
			};
			if(config.loadingNode)
				rootState.loadingNode = config.loadingNode;
			else
				rootState.loadingNode = '';
			
			global.setRootState(rootState);
		}
		let headers = {
			"Content-Type": "application/json",
			"Accept": "application/json",
		};
		if(param instanceof FormData)
			headers['Content-Type'] = 'multipart/form-data';
		let axiosConfig = {
			url: url,
			method: "POST",
			data:param,
			headers: headers,
		};
		if(config.onUploadProgress)
			axiosConfig.onUploadProgress = (progressEvent)=>{
				config.onUploadProgress(progressEvent);
			};
		if(config.onDownloadProgress)
			axiosConfig.onDownloadProgress = (progressEvent)=>{
				config.onDownloadProgress(progressEvent);
			};
		
		axios(axiosConfig)
		.then(response =>{
			let data = response.data;
			
			if(!config.hideAjax)
				global.setRootState({ 'isLoading':false });
			if(config.rawResponse)
			{
				resolve(data);
				return;
			}
			
			if(data.code!=0)
			{
				//未登录
				if(data.code == -10)
				{
					let url = window.location.href;
					url = url.split('#');
					url = url[1];
					if(url.indexOf('/login') === 0) return;
					window.location.href=ngUrl('login',{'redirect':url},true);
					//window.location.href=ngUrl('login');
					return;
				}
				
				message(data.message);
				reject(data);
				return;
			}
			
			resolve(data.data);
		})
		.catch(error=>{
			if(!config.hideAjax)
				global.setRootState({ 'isLoading':false });
			
			/*
			let response=error.response;
			let data=response.data;
			*/
			message('接口请求错误');
			reject();
		});
	});
};

export const scanPost =  (url,param,config)=> {
	return new Promise((resolve,reject)=>{
		httpPost(url,param,config)
			.then(data=>{
				resolve(data);
			})
			.catch(data=>{
				//处理未登录流程
				if(data && data.code)
				{
					if(data.code == -20)
					{
						window.location.href=ngUrl('scan/login',{'redirect':url},true);
						return;
					}
				}
				
				reject(data);
			});
	});
};

export const download = (url,param)=>{
	if(param==undefined)
		param={};
	
	return new Promise((resolve,reject)=>{
		axios({
			url: url,
			method: 'post',
			data: param,
			responseType: 'blob',
			headers: {
				'Content-Type': 'application/json',
			},
  			timeout: 600000 // request timeout
		})
		.then(response=>{
			if(response.status != 200)
			{
				message('下载出现错误，错误码为'+response.status);
				return;
			}
			const name = response.headers['content-disposition'].split(';')[1].split('=')[1]
			const content = response.data
			const blob = new Blob([content])
			const fileName =  decodeURI(name)
			if ('download' in document.createElement('a')) { // 非IE下载
				const elink = document.createElement('a')
				elink.download = fileName
				elink.style.display = 'none'
				elink.href = URL.createObjectURL(blob)
				document.body.appendChild(elink)
				elink.click()
				URL.revokeObjectURL(elink.href) // 释放URL 对象
				document.body.removeChild(elink)
				resolve()
			} else { // IE10+下载
				navigator.msSaveBlob(blob, fileName)
				resolve()
			}
		})
		.catch(error=>{
			reject(error);
		});
	});
};

export const alert = (message)=> {
	return new Promise((resolve,reject)=>{
		Modal.info({
			title: '提示',
			content: message,
			onOk() {resolve();},
		});
	});
};
export const confirm = (message)=> {
	return new Promise((resolve,reject)=>{
		Modal.confirm({
			title: '提示',
			content: message,
			onOk() {resolve();},
			onCancel() { reject();},
		});
	});
};
export const message = (message,status,duration)=> {
	if(!status) status = 'error';
	if(!duration) duration = 3;
	return new Promise((resolve,reject)=>{
		message1[status](message,duration,()=>{
			resolve();
		});
	});
};

export const notify = (message,status)=> {
	if(!status) status = 'success';
	notification[status]({
		message: '提示',
		description: message,
	});
};


export const java2c = (name) => {
	let length=name.length;
	let arr=[];
	let i,j;
	let str;
	
	for(i=0,j=0;i<length;i++)
	{
		if( name[i]>='A' && name[i]<='Z' && i!=0 )
		{
			str=name.substr(j,i-j);
			arr.push(str);
			j=i;
		}
	}
	
	str=name.substr(j,i-j);
	arr.push(str);
	name=arr.join('_').toLowerCase();
	return name;
}

export const c2java = (name) => {
	let temp=name.split('_');
	name='';
	temp.forEach((str)=>{
		str=str.replace(str[0],str[0].toUpperCase());
		name+=str;
	});
	
	return name;
}

export const c2camel = (name) => {
	let temp=name.split('_');
	name='';
	temp.forEach((str,index)=>{
		if(index!=0)
			str=str.replace(str[0],str[0].toUpperCase());
		
		name+=str;
	});
	
	return name;
}

export const scrollTop = () => {
	//$('html ,body').animate({scrollTop: 0}, 300);
	$('#page-wrapper').animate({scrollTop: 0}, 300);
}

export const parseQuery = (search) => {
	search=search.replace('?','').split('&');
	let query={};
	search.forEach((str)=>{
		str=str.split('=');
		query[str[0]]=str[1];
	});
	return query;
}

export const parseTime = (time) => {
	return formatTime('Y-m-d H:i:s',time);
}

export const formatTime = (format,time) => {
	if(time!=undefined)
		var t=new Date(time*1000);
	else
		var t=new Date();
	
	let str=format;
	str=str.replace('Y',formatNumber(t.getFullYear()));
	str=str.replace('m',formatNumber((t.getMonth()+1)));
	str=str.replace('d',formatNumber(t.getDate()));
	str=str.replace('H',formatNumber(t.getHours()));
	str=str.replace('i',formatNumber(t.getMinutes()));
	str=str.replace('s',formatNumber(t.getSeconds()));
	return str;
}

export const formatNumber = (num) => {
	if(num<10) num='0'+num;
		return num;
}

export const getQuery = (key) => {
	let url=window.location.href;
	
	url=url.split('?');
	if(url.length<=1 || url[1]=='') return key?'':{};
	var query=url[1];
	query=query.split('&');
	var params={};
	var c,a;
	
	for(var i=0;i<query.length;i++)
	{
		if(query[i]=='' ) continue;
		query[i]=query[i].split('=');
		params[query[i][0]]=query[i][1];
	}
	
	if(key!=undefined)
		return params[key];
	else
		return params;
}

export const strlen = (str) => {
	let len = 0;
	for (let i=0; i<str.length; i++) {
		let c = str.charCodeAt(i);
		//单字节加1
		if ((c >= 0x0001 && c <= 0x007e) || (0xff60<=c && c<=0xff9f)) {
			len++;
		}
		else {
			len+=2;
		}
	}
	return len;
}

export const getScrollbarWidth = () => {
	var odiv = document.createElement('div'),//创建一个div
		styles = {
			width: '100px',
			height: '100px',
			overflowY: 'scroll'//让他有滚动条
		}, i, scrollbarWidth;
	for (i in styles) odiv.style[i] = styles[i];
	document.body.appendChild(odiv);//把div添加到body中
	scrollbarWidth = odiv.offsetWidth - odiv.clientWidth;//相减
	odiv.remove();//移除创建的div
	return scrollbarWidth;//返回滚动条宽度
}

export const debounce =  (func, wait, immediate) => {
	let timeout, args, context, timestamp, result

	const later = function() {
		// 据上一次触发时间间隔
		const last = +new Date() - timestamp

		// 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
		if (last < wait && last > 0) {
			timeout = setTimeout(later, wait - last)
		} else {
			timeout = null
			// 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
			if (!immediate) {
				result = func.apply(context, args)
				if (!timeout) context = args = null
			}
		}
	}

	return function(...args) {
		context = this
		timestamp = +new Date()
		const callNow = immediate && !timeout
		// 如果延时不存在，重新设定延时
		if (!timeout) timeout = setTimeout(later, wait)
		if (callNow) {
			result = func.apply(context, args)
			context = args = null
		}

		return result
	}
}

export const accDiv = (arg1,arg2) =>{
    var t1=0,t2=0,r1,r2;
    try{t1=arg1.toString().split(".")[1].length}catch(e){}
    try{t2=arg2.toString().split(".")[1].length}catch(e){}
	r1=Number(arg1.toString().replace(".",""))
	r2=Number(arg2.toString().replace(".",""))
	return (r1/r2)*Math.pow(10,t2-t1);
}

export const accMul = (arg1,arg2) => {
    var m=0,s1=arg1.toString(),s2=arg2.toString();
    try{m+=s1.split(".")[1].length}catch(e){}
    try{m+=s2.split(".")[1].length}catch(e){}
    return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
}

export const accAdd = (arg1,arg2) => {
    var r1,r2,m;
    try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
    try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
    m=Math.pow(10,Math.max(r1,r2))
    return (arg1*m+arg2*m)/m
}
